module.exports = __webpack_public_path__ + "img/livu-logo.5dcc2c4d.png";